import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Row, Col,ButtonGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { DashboardAction } from 'redux/actions';
import { checkPermissions } from 'hooks';
import { Link } from 'react-router-dom';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};


const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    background: isDragging ? 'rgb(58 172 214)' : 'rgb(58 172 214)',
    color: '#fff',
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    padding: grid,
    minHeight: '64px',
    border: '1px dashed #6c757d'
});


const WidgetSelector = (props) => {



    const type = props.type;
    let [items, setItems] = React.useState([]);


    React.useEffect(() => {

        let widgetItems = [];
        if (type === 'ADS') {
            checkPermissions(props.loginData, 'campaign_analytics') && widgetItems.push({ id: `AdsAnalytics`, permission:'campaign_analytics', content: `Campaign Analytics` });
        } else {
            checkPermissions(props.loginData, 'dashboard_data') && widgetItems.push({ id: `SwisAnalytics`, permission:'dashboard_data', content: `Swis Analytics` });
            checkPermissions(props.loginData, 'google_analytics') && widgetItems.push({ id: `GoogleAnalytics`,permission:'google_analytics', content: `Google Analytics` });
            checkPermissions(props.loginData, 'google_analytics_graph') && widgetItems.push({ id: `GoogleAnalyticsGraph`,permission:'google_analytics_graph', content: `Google Analytics Graph` });
            checkPermissions(props.loginData, 'top_searches') && widgetItems.push({ id: `TopSearches`,permission:'top_searches', content: `Top Searches` });
            checkPermissions(props.loginData, 'top_searches') && widgetItems.push({ id: `PopularSearches`,permission:'top_searches', content: `Popular Searches` });
            checkPermissions(props.loginData, 'failed_urls') && widgetItems.push({ id: `FailedUrlGraph`,permission:'failed_urls', content: `Failed Urls Graph` });
            checkPermissions(props.loginData, 'users_locations') && widgetItems.push({ id: `MapComp`,permission:'users_locations', content: `Users Location` });
        }
        setItems(widgetItems);
    }, [props.loginData,props.type]);


    let [state, setState] = React.useState({
        items: items,
        selected: []
    })



    let id2List = {
        droppable: 'items',
        droppable2: 'selected'
    };

    const getList = (id) => {
        return state[id2List[id]];
    }



    React.useEffect(() => {

        if (props.widgetSaved && (props.widgetSaved).length > 0) {

            const widgetFound = (props.widgetSaved).find((item) => item.type === props.type)
            let selected = []
            if(widgetFound){
                selected = (widgetFound.widget_json) ? JSON.parse(widgetFound.widget_json) : [];
                items = items.filter((item) => ((selected).findIndex((it) => it.id === item.id) < 0) ? true : false);
                setState({
                    items: items,
                    selected: selected
                })
            }
            else {
                setState({
                    items: items,
                    selected: []
                })
            }
        } else {
            setState({
                items: items,
                selected: []
            })
        }
    }, [props.widgetSaved, items,props.type]);

    

    const onDragEnd = result => {
        const { source, destination } = result;
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {
            const items = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            );
            if (source.droppableId === 'droppable2') {
                props.saveDashboardWidget({ widget_json: items });
            }
        } else {
            const result = move(
                getList(source.droppableId),
                getList(destination.droppableId),
                source,
                destination
            );
            setItems(result.droppable)
            props.saveDashboardWidget({ widget_json: result.droppable2, type: type });
        }

    };


    return (
        <div>
            <ButtonGroup className="mr-3 mb-3">
                <Link className={`btn group-btn ${props.type==='POST' && 'active'}`} to={`/dashboard-widgets/POST`}>Users and Searches</Link>
                <Link className={`btn group-btn ${props.type==='ADS' && 'active'}`} to={`/dashboard-widgets/ADS`}>Campaign</Link>
                
            </ButtonGroup>
            <DragDropContext onDragEnd={onDragEnd}>
                <Row>
                    <Col md={6}>
                        <h6>Widgets List</h6>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {(state.items && state.items.length > 0) && state.items.map((item, index) => (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    {item.content}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Col>
                    <Col md={6}>
                        <h6>Selected Widgets</h6>
                        <Droppable droppableId="droppable2">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {(state.selected && state.selected.length > 0) && state.selected.map((item, index) => {
                                        if(checkPermissions(props.loginData, `${item.permission}`)){
                                        return <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    {item.content}
                                                </div>
                                            )}
                                        </Draggable>
                                        }else{
                                            return null
                                        }
}
                                    
                                    )}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Col>
                </Row>
            </DragDropContext>
        </div>
    );
};

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    widgetSaved: (state.dashboard && state.dashboard.widgetSaved) ? state.dashboard.widgetSaved : [],
});
const mapDispatchToProps = (dispatch) => ({
    saveDashboardWidget: (payload) => dispatch(DashboardAction.saveDashboardWidget(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(WidgetSelector);